import arrowDown from "/assets/arrow-down.svg";
import checkMark from "/assets/check-mark.svg";
import close from "/assets/close.svg";
import { useState, useEffect, useRef } from "react";

export default function MultiSelect({
  label,
  placeholder,
  value = [],
  locale,
  options = [],
  onChange,
  disabled = false,
  errors = [],
}) {
  if (typeof onChange !== "function" && !disabled)
    console.debug("A multi-select doesn't have an onChange callback");

  const [isValid, setIsValid] = useState(errors.length == 0);
  const [isOptionsVisible, setIsOptionsVisible] = useState(false);
  const wrapperRef = useRef(null);
  const optionsRef = useRef(null);
  const labelRef = useRef(null);
  const normValue = value.map(v => v.toString());

  useEffect(() => {
    setIsValid(errors.length == 0);
  }, [errors]);

  useEffect(() => {
    const handleOutsideClick = event => {
      if (!wrapperRef.current || !optionsRef.current) return;

      if (!wrapperRef.current.contains(event.target) &&
          !optionsRef.current.contains(event.target) &&
          !labelRef.current.contains(event.target))
        setIsOptionsVisible(false);
    }

    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [wrapperRef]);

  const toggleOptionsVisible = () => {
    if (disabled) return;

    setIsOptionsVisible(currentValue => !currentValue);
  };

  const toggleOption = (targetOption) => {
    if (normValue.includes(targetOption)) {
      removeOption(targetOption);
    } else {
      addOption(targetOption);
    }
  };

  const addOption = (key) => {
    if (typeof onChange !== 'function') return;

    onChange([...value, key]);
    setIsValid(true);
  };

  const removeOption = (key) => {
    if (typeof onChange !== 'function') return;

    onChange(value.filter(o => o != key));
    setIsValid(true);
  };

  return (
    <div className="inpt-grp">
      {label && (
        <label onClick={toggleOptionsVisible} ref={labelRef} className="lbl">{label}</label>
      )}
      <div className="inpt-select-wrapper">
        <div className={`inpt-select ${disabled ? "inpt-select-disabled" : ""}`} onClick={toggleOptionsVisible} ref={wrapperRef}>
          <span className="inpt-select-value">
            {value.length > 0 ? (
              <>
                {value.map(selectedKey => (
                  <div key={selectedKey} className="inpt-select-selected-value">
                    {locale ? options[selectedKey][locale] : options[selectedKey]}
                    {!disabled && (<img src={close} onClick={(event) => { event.stopPropagation(); removeOption(selectedKey) }} />)}
                  </div>
                ))}
              </>
            ) : placeholder}
          </span>

          {!disabled && (
            <img src={arrowDown} className={`inpt-select-icon ${isOptionsVisible ? "inpt-select-icon-open" : ""}`} />
          )}
        </div>

        {!isValid && errors.map((error, index) => (
          <label key={index} className="lbl lbl--error">{error}</label>
        ))}

        {isOptionsVisible && (
          <ul className="inpt-select-options" ref={optionsRef}>
            {Object.entries(options).map(([key, data]) => (
              <li
                key={key}
                className={normValue.includes(key) && "selected"}
                onClick={() => toggleOption(key)}
              >
                <div className="inpt-select-checkbox">
                  <img src={checkMark} />
                </div>

                {locale ? data[locale] : data}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
